<template>
  <div class="personalHead">
    <h2 :class="hide?'title':'title_hide'">{{title}}</h2>
    <p class="xing" v-if="hide"><el-button class="back" v-if="back" @click="goBack()" type="danger" plain>返 回</el-button></p>
    <p class="line" v-if="hide"></p>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    hide: Boolean,
    back:Boolean,
  },
  data() {
    return {};
  },
  methods: {
     goBack(){
        this.$emit('goBack')
     }
  }
};
</script>

<style lang="less" scoped>
.personalHead {
  .title {
    display: inline-block;
    margin: 2px;
  }
  .title_hide {
    display: inline-block;
    margin: 2px;
  }
  padding: 0px 20px 10px 20px;
  .xing {
    color: #ea0000;
    margin: 10px 0px 0px 0px;
    position: relative;
    .back{
       position: absolute;
       right:0px;
       top: -15px;
    }
  }
  .line {
    width: 100%;
    height: 2px;
    background: #c4c4c4;
    margin: 10px 0px;
  }
}
</style>